module.exports = __webpack_public_path__ + "img/uk_failure_7.1fe30ce4.png";